import type { FloatingPosition, StackProps } from "@mantine/core";
import { Stack, Text, Tooltip } from "@mantine/core";
import { TimeValue } from "@mantine/dates";
import type { MessageSender } from "@/sdk";
import { classNames } from "@/shared-utils";
import classes from "./message-component-styles.module.css";

interface MessageBubbleProps extends StackProps {
    flexAlign: "flex-start" | "flex-end";
    senderType: MessageSender;
    lastOfGroup?: boolean;
    messageTime?: Date | null;
}

/** Displays a chat message bubble with a tooltip showing the message time on hover */
export function MessageBubble({
    children,
    flexAlign,
    lastOfGroup = false,
    senderType,
    messageTime,
    ...rest
}: MessageBubbleProps) {
    const tooltipPosition: FloatingPosition = flexAlign === "flex-end" ? "right" : "left";

    const TooltipLabel = messageTime ? (
        <Text size="sm" tt="lowercase">
            <TimeValue value={messageTime} format="12h" />
        </Text>
    ) : null;

    return (
        <Tooltip
            label={TooltipLabel}
            position={tooltipPosition}
            disabled={!messageTime}
            p="xs"
            openDelay={300}
            aria-label="Message time"
        >
            <Stack
                className={classNames("fs-mask", classes.bubble)}
                data-flex-align={flexAlign}
                data-sender-type={senderType}
                data-last-of-group={lastOfGroup}
                {...rest}
            >
                {children}
            </Stack>
        </Tooltip>
    );
}
